import { useParams } from 'react-router-dom'
import { useAutoPrint } from '../hooks/useAutoPrint'
import PendingPrintDialog from './PendingPrintDialog'

/**
 * 案A: 店舗レイアウト直下に常駐し、どの店舗ページを開いていても注文伝票を自動印刷
 * する headless コンポーネント。storeId はルート params (/store/.../:storeId) から取得。
 * storeId が無いページ (一部の一覧系) では useAutoPrint 側で no-op になる。
 *
 * #1960 完全な headless ではなくなった — **溜まっていた伝票をいきなり刷る前に
 * 確認を出す**。自動印刷はどの店舗ページでも動くので、確認もここに置かないと
 * 「厨房ページを開いていないと聞かれない」ことになる。
 */
export default function AutoPrintMount() {
  const { storeId } = useParams()
  const { pendingBurst, printAllPending, discardPending, snoozePending } = useAutoPrint(storeId)

  if (!pendingBurst?.length) return null
  return (
    <PendingPrintDialog
      count={pendingBurst.length}
      onPrintAll={printAllPending}
      onDiscard={discardPending}
      onSnooze={snoozePending}
    />
  )
}
